/**
 * Analytics — Security Audit API Contracts
 *
 * Wire format for SecurityAuditController endpoints.
 */

import { z } from 'zod';

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

// ---------------------------------------------------------------------------
// Request schemas
// ---------------------------------------------------------------------------

export const ListSecurityAlertsQuerySchema = z.object({
  severity: z.enum(['low', 'medium', 'high', 'critical']).optional(),
  source: z.string().optional(),
  eventType: z.string().optional(),
  dateFrom: z.string().regex(DATE_REGEX).optional(),
  dateTo: z.string().regex(DATE_REGEX).optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type ListSecurityAlertsQuery = z.infer<typeof ListSecurityAlertsQuerySchema>;

// ---------------------------------------------------------------------------
// Response schemas
// ---------------------------------------------------------------------------

export const SecurityAlertRecordSchema = z.object({
  id: z.string(),
  eventType: z.string(),
  source: z.string(),
  severity: z.enum(['low', 'medium', 'high', 'critical']),
  message: z.string(),
  details: z.unknown().nullable().optional(),
  emittedAt: z.string(),
  createdAt: z.string(),
});
export type SecurityAlertRecord = z.infer<typeof SecurityAlertRecordSchema>;

export const ListSecurityAlertsResponseSchema = z.object({
  alerts: z.array(SecurityAlertRecordSchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  totalPages: z.number().int(),
});
export type ListSecurityAlertsResponse = z.infer<typeof ListSecurityAlertsResponseSchema>;
